import { css, SerializedStyles } from '@emotion/react';

export const useMainLayoutStyles = (theme): SerializedStyles => css`
  background-color: ${theme.palette.background.dark};
  display: flex;
  overflow: hidden;
  width: 100%;
  height: 100%;

  .wrapper {
    display: flex;
    flex: 1 1 auto;
    overflow: hidden;
    padding-top: ${theme.spacing(8)};

    ${theme.breakpoints.up('md')} {
      padding-left: 240px;
    }
  }

  .content-container {
    display: flex;
    flex: 1 1 auto;
    overflow: hidden;
  }

  .content {
    flex: 1 1 auto;
    height: 100%;
    overflow: auto;
    padding: ${theme.spacing(3)};

    ${theme.breakpoints.down('md')} {
      padding: ${theme.spacing(3, 0)};
    }
  }
`;
